import { Form, FormResponseValue } from "@tellescope/types-models";
import { TellescopeFormFieldBaseProps } from "../../types";
import { StripeFieldContent } from "./StripeFieldContent";
import { Label } from "@tellescope/ui";
import { FieldDescription } from "../../FieldDescription";

export interface StripeFieldProps extends TellescopeFormFieldBaseProps<"Stripe"> {
  enduserId: string;
  form: Form;
  formResponses: FormResponseValue[];
  setCustomerId?: (customerId: string) => void;
}

export const StripeField = ({ title, description, htmlDescription, required, ...rest }: StripeFieldProps) => {
  return (
    <div className="space-y-1">
      {!!title && <Label required={required}>{title}</Label>}
      <FieldDescription description={description} htmlDescription={htmlDescription} />
      <StripeFieldContent {...rest} />
    </div>
  );
};
